import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgBananiLogoSmall = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		opacity: .9,
		d: "M8.25018 10.3631C10.5978 6.2969 13.762 3.72871 15.3176 4.62681C16.7997 5.48276 16.2854 9.17639 14.2023 13.0409C15.0967 12.6848 16.1102 12.7157 16.9748 13.2147C18.5303 14.1128 19.0142 16.1866 18.0558 17.8465C17.0974 19.5064 15.0596 20.1245 13.5041 19.2264C12.4996 18.6464 11.9427 17.5757 11.9318 16.4432C10.0006 18.7801 7.96741 20.0164 6.81561 19.3514C5.26062 18.4529 5.90288 14.4289 8.25018 10.3631Z",
		stroke: "currentColor",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
export default SvgBananiLogoSmall;
